/**
 * OmniLeagues - Booking API helper (shared by dashboard panel + public page)
 */
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

// ---------- Host (auth) ----------
export const listEventTypes = (orgId) =>
  axios.get(`${API}/api/booking/event-types/${orgId}`).then((r) => r.data);

export const createEventType = (orgId, body) =>
  axios.post(`${API}/api/booking/event-types/${orgId}`, body).then((r) => r.data);

export const getEventType = (orgId, id) =>
  axios.get(`${API}/api/booking/event-types/${orgId}/${id}`).then((r) => r.data);

export const updateEventType = (orgId, id, body) =>
  axios.patch(`${API}/api/booking/event-types/${orgId}/${id}`, body).then((r) => r.data);

export const deleteEventType = (orgId, id) =>
  axios.delete(`${API}/api/booking/event-types/${orgId}/${id}`).then((r) => r.data);

export const rotateLink = (orgId, id) =>
  axios.post(`${API}/api/booking/event-types/${orgId}/${id}/rotate-link`).then((r) => r.data);

export const listRequests = (orgId, status) =>
  axios
    .get(`${API}/api/booking/requests/${orgId}`, { params: status ? { status } : {} })
    .then((r) => r.data);

export const approveRequest = (orgId, id) =>
  axios.post(`${API}/api/booking/requests/${orgId}/${id}/approve`, {}).then((r) => r.data);

export const declineRequest = (orgId, id, reason) =>
  axios
    .post(`${API}/api/booking/requests/${orgId}/${id}/decline`, { reason })
    .then((r) => r.data);

// ---------- Public (no auth) ----------
export const publicHub = (orgId) =>
  axios.get(`${API}/api/booking/public/${orgId}`, { withCredentials: false }).then((r) => r.data);

export const publicEventType = (orgId, slug, token) =>
  axios
    .get(`${API}/api/booking/public/${orgId}/${slug}`, {
      params: token ? { token } : {},
      withCredentials: false,
    })
    .then((r) => r.data);

export const publicSlots = (orgId, slug, fromDate, toDate) =>
  axios
    .get(`${API}/api/booking/public/${orgId}/${slug}/slots`, {
      params: { date_from: fromDate, date_to: toDate },
      withCredentials: false,
    })
    .then((r) => r.data);

export const publicSubmit = (orgId, slug, body) =>
  axios
    .post(`${API}/api/booking/public/${orgId}/${slug}/requests`, body, { withCredentials: false })
    .then((r) => r.data);

export const publicManage = (token) =>
  axios
    .get(`${API}/api/booking/public/manage/${token}`, { withCredentials: false })
    .then((r) => r.data);

export const publicCancel = (token) =>
  axios
    .post(`${API}/api/booking/public/manage/${token}/cancel`, {}, { withCredentials: false })
    .then((r) => r.data);

// ---------- helpers ----------
export const formatInTz = (utcIso, tz) => {
  if (!utcIso) return '';
  try {
    const d = new Date(utcIso);
    return new Intl.DateTimeFormat('en-US', {
      weekday: 'short',
      month: 'short',
      day: 'numeric',
      year: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
      timeZone: tz || 'America/New_York',
      timeZoneName: 'short',
    }).format(d);
  } catch {
    return utcIso;
  }
};

export const formatTimeOnly = (utcIso, tz) => {
  if (!utcIso) return '';
  try {
    const d = new Date(utcIso);
    return new Intl.DateTimeFormat('en-US', {
      hour: 'numeric',
      minute: '2-digit',
      timeZone: tz || 'America/New_York',
    }).format(d);
  } catch {
    return utcIso;
  }
};

export const dateKeyInTz = (utcIso, tz) => {
  if (!utcIso) return '';
  try {
    const d = new Date(utcIso);
    const parts = new Intl.DateTimeFormat('en-CA', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      timeZone: tz || 'America/New_York',
    }).formatToParts(d);
    const y = parts.find((p) => p.type === 'year').value;
    const m = parts.find((p) => p.type === 'month').value;
    const day = parts.find((p) => p.type === 'day').value;
    return `${y}-${m}-${day}`;
  } catch {
    return '';
  }
};

export const DAYS_OF_WEEK = [
  { value: 0, label: 'Mon' },
  { value: 1, label: 'Tue' },
  { value: 2, label: 'Wed' },
  { value: 3, label: 'Thu' },
  { value: 4, label: 'Fri' },
  { value: 5, label: 'Sat' },
  { value: 6, label: 'Sun' },
];
